import {
    AfterViewInit,
    Component,
    ElementRef,
    OnInit,
    Renderer2,
} from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Component({
    selector: 'vb-terms-and-conditions-page',
    templateUrl: './terms-and-conditions-page.component.html',
    styleUrls: ['./terms-and-conditions-page.component.css'],
})
export class TermsAndConditionsPageComponent implements OnInit, AfterViewInit {
    getTnCTxt = '';
    constructor(
        private http: HttpClient,
        private renderer: Renderer2,
        private el: ElementRef,
    ) {}

    ngOnInit(): void {
        this.http
            .get('./assets/viewbid/staticFiles/termsandconditions.txt', {
                responseType: 'text',
            })
            .subscribe((data: any) => {
                this.getTnCTxt = data;
            });
    }

    // Manually applying styles to override the existing theme styles.
    // Since the content of privacypolicy.txt is rendered after CSS classes are applied,
    // inline styles must be applied directly to the inner HTML.
    ngAfterViewInit(): void {
        setTimeout(() => {
            const element: any = this.el.nativeElement.querySelectorAll(
                '.dynamic-content ul',
            );

            if (element) {
                const listItems: any = element.querySelectorAll('li');
                listItems.forEach((li: HTMLElement) => {
                    this.renderer.setStyle(li, 'margin-left', '15px');
                });
            }
        }, 100);
    }
}
